export const shouldFetchCircleCollections = (state, props) => {};

const isFetchingCollections = (state, props) => {
  if (state.circle_collection.loading === true) {
    return true;
  } else {
    return false;
  }
};
const shouldFetchCollections = (state, props) => {
  //TODO: here we can add an expiration date to the content so we can refresh it if needed
  if (isFetchingCollections(state, props)) {   
    return false;
  }
  // if (state.circle_collection.list.length) {
  //   // if(state.circle_collection.list[0].key=='husqvarna'){
  //   //   return true;
  //   // }else{
  //     return false;
  //   // }    
  // }
  return true;
};

const translatedCircleCollections =(state, order) => {
  let collections = [...state.circle_collection.list];
  const lang = state.i18n.locale;
  collections.forEach(collection => {
    collection["name"] = collection[`name_${lang}`];
    collection["heading"] = collection[`heading_${lang}`];
    collection["short_description"] = collection[`short_description_${lang}`];
    collection["description"] = collection[`description_${lang}`];
  });
  
  if(order && collections.length){
    let collection_by_keys = {};
    let ordered_collections = [];
    collections.forEach(collection=>{
      collection_by_keys[collection.key] = collection;
    })
    
    order.forEach(collection_key=>{
      ordered_collections.push(collection_by_keys[collection_key]);
    })
    collections = ordered_collections;
  }

  return collections;
};

export {
  isFetchingCollections,
  shouldFetchCollections,
  translatedCircleCollections
};
